<template>


  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>users can save</p>
    <div class='has-text-left'>
      <p>Surprisingly, the majority of users did not spread the virus at all. Only <span class='myNumber'>1 in 3</span> users infected someone else.</p>
      <br>
      <p class='chartTitle'>Figure 5:  Infectors vs. non-infectors
      <hr class='rule'>
    </div>

    <div>
      <div v-if="mobile" class='has-text-left'>
        <ul class='legendList'>
          <li class='myNumber is-size-6'>{{ spreaderPieChart[1][0] }}</li>
          <li class='userName is-size-6'>{{ spreaderPieChart[2][0] }}</li>
        </ul>
      </div>
      <GChart
        type="PieChart"
        :data="spreaderPieChart"
        :options="{
          pieHole: .6,
          backgroundColor: '#F0F0F0',
          chartArea: {backgroundColor: '#F0F0F0', height: 150, width: '100%'},
          colors: ['#3298DC', '#F14668'],
          legend: responsivePieChartLegend,
          pieSliceText: 'none',
        }"
      ></GChart>
    </div>
  </div>

</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  props: ['mobile'],
  data() {
    return {
      spreaderPieChart: [
        ['group', 'count'],
        ['infected other users', 42007],
        ['did not infect other users', 84843]
      ],
    }
  },
  computed: {
    responsivePieChartLegend() {
      let desktopLegend = {
        alignment: 'center',
        position: 'labeled',
        textStyle: {fontSize: 14}
      };
      let mobileLegend = {
        position: 'none'
      };
      return this.mobile ? mobileLegend : desktopLegend;
    },
  },
  components: {
    GChart
  }
}


</script>